/**
 * 創作者入駐 — 繁體中文（對應 t('creatorJoin.…')）
 */
export default {
	// vue-i18n 会把 | 当成复数分隔符，字面量需写成 {'|'}
	pageTitle: "先知命局 {'|'} 創作者合作計劃",
	index: {
		banner: {
			eyebrow: "SeerQ Creator Programme",
			title: "讓你的智慧，<span>被更多人看見</span>",
			titleM: "讓你的智慧，<span>被更多人看見</span>",
			desc: "我們正在尋找專注於身心成長與智慧內容的創作者。加入先知命局，讓你的專業連結真正需要它的人。",
			recruitTitle: "正在招募這些領域的創作者",
			tag1: "心理學",
			tag2: "身心療癒",
			tag3: "塔羅占星",
			tag4: "東方玄學",
			tag5: "精神舒緩",
			joinCta: "申請成為創作者",
			benefitsCta: "了解合作權益",
		},
		download: {
			title: "先知命局，陪你找到人生方向",
			slogan: "See Beyond",
		},
		about: {
			eyebrow: "About SeerQ · 品牌介紹",
			title: "讓傳統智慧，成為現代人的生活指南。",
			desc: "全球首個亞裔專屬文化健康超級工具應用，開創亞洲傳統智慧數字化健康指導新賽道。打造一個集內容引流＋交易變現+AI 服務於一體的健康伴侶工具超級 App，「內容到商業」閉環的綜合健康生活方式平台。",
			highlight1: "<span>· 品牌使命：</span>先知命局，陪你找到人生方向",
			highlight2: "<span>· 品牌 slogan：</span>見•未見",
			highlight3: "<span>· SeerQ：</span>See Beyond",
		},
		platform: {
			eyebrow: "The SeerQ Creator Platform · 創作平台",
			title: "讓內容被看見，讓創作者被記住。",
			desc: "先知命局 App 匯聚關注亞洲文化健康、個人成長與東方智慧的用戶，是一個<span>讓專業內容持續被發現的創作社群</span>。在這裡分享觀點、連結同頻受眾，讓內容影響力逐步沉澱為個人品牌與商業價值。",
			card1Title: "多形式內容創作",
			card1Desc: "發佈短影片、圖文、長文與直播，用一個帳號管理作品，持續輸出你的觀點與專業。",
			card2Title: "垂直流量與社群",
			card2Desc:
				"根據用戶興趣與內容標籤精準推薦，持續連結真正關注文化健康與個人成長的受眾，累積更高黏性的粉絲社群。",
			card3Title: "創作者主頁與變現",
			card3Desc: "建立可持續經營的個人主頁，沉澱粉絲與內容資產，連接付費內容、諮詢服務與品牌合作。",
			beimei: "北美 15%",
			dongnanya: "東南亞 50%",
			rihan: "日韓 10%",
			qita: "其他地區 25%",
		},
		audience: {
			eyebrow: "不只是一個內容平台",
			title: "你的下一批忠實粉絲，已經在這裡。",
			desc: "聚集重視生活品質、個人成長與東西方智慧的高意願用戶，讓好內容有機會被理解、被回應，也被付費。",
			stat1Value: "426",
			stat1Suffix: "K",
			stat1Label: "每月 App 登入用戶",
			stat2Value: "3,786",
			stat2Suffix: "K",
			stat2Label: "每月內容瀏覽量",
			stat3Value: "796",
			stat3Suffix: "K",
			stat3Label: "YouTube 不重複閱聽眾",
			stat4Value: "174",
			stat4Suffix: "K",
			stat4Label: "Facebook 追蹤者",
			personaAge: "28-45",
			personaAgeUnit: "歲",
			personaAgeLabel: "核心\n年齡層",
			personaUserLabel: "核心\n用戶畫像",
			personaTag1: "職場菁英",
			personaTag2: "高消費意願",
			personaTag3: "關注個人成長",
			personaTag4: "樂於交流分享",
		},
		support: {
			eyebrow: "Creator Support · 專屬支持",
			title: "我們提供的，<span>遠不止</span>是一個平台。",
			desc: "從內容生產、個人品牌到商業合作，專業團隊陪你把每一份智慧轉化為長期影響力。",
			card1Title: "創作更高效",
			card1Desc: "從選題、製作到發佈，減少重複工作，把時間留給專業表達。",
			card1Item1: "· 趨勢選題共創",
			card1Item2: "· 內容製作加速",
			card1Item3: "· 原創版權保障",
			card2Title: "讓專業成為品牌",
			card2Desc: "從定位、曝光到粉絲經營，建立清晰可信的個人品牌。",
			card2Item1: "· 定位與形象塑造",
			card2Item2: "· 精準流量扶持",
			card2Item3: "· 深度粉絲連結",
			card3Title: "讓影響力持續變現",
			card3Desc: "連接品牌合作與知識產品，拓展更長期的收入空間。",
			card3Item1: "· 商務機會匹配",
			card3Item2: "· 知識產品化",
			card3Item3: "· 法律合規護航",
		},
		partnership: {
			eyebrow: "Flexible Partnership",
			title: "選擇適合你現階段的合作方式。",
			desc: "不論剛起步、已有專業積累，或已是領域頭部，都有清晰的成長路徑。",
			tier1Badge: "基礎創作者",
			tier1Title: "開通內容發佈、基礎流量推薦與內容付費功能。",
			tier1Desc: "適合準備分享專業智慧的創作者",
			tier1Sub: "",
			tier1Cta: "選擇此方案",
			tier2Badge: "認證 KOL",
			tier2Title: "加享專屬營運指導、活動優先參與與官方認證標識。",
			tier2Desc: "適合準備分享專業智慧的創作者",
			tier2Sub: "",
			tier2Cta: "選擇此方案",
			tier3Badge: "獨家戰略夥伴",
			tier3Title: "頂級流量、個人 IP 打造、全網宣發與保底收入加分潤。",
			tier3Desc: "適合具影響力的頭部 KOL",
			tier3Sub: '<span><a href="mailto:zixun@seeronnet.com">zixun@seeronnet.com</a></span>',
			tier3Cta: "郵件洽談",
		},
		growth: {
			eyebrow: "Real Growth",
			title: "真實數據，見證創作者成長。",
			case1Value: "300",
			case1Suffix: "%",
			case1Metric: "諮詢量提升",
			case1Author: "{'@'}占星老師 Jupiter",
			case1Desc:
				"以獨創「七年星座運勢」欄目精準連結目標受眾，帶動諮詢量提升 300%，高端客戶占比與整體客單價同步成長。",
			case2Value: "200",
			case2Suffix: "K+",
			case2Metric: "6個月累計播放",
			case2Author: "{'@'}飛叔",
			case2Desc:
				"入駐初期單支影片播放量不足 100；參與平台創作者激勵計劃後，6 個月累計影片播放量突破 200K+。",
			disclaimer: "*成果依內容品質、投入程度與受眾基礎而異，案例不代表收益保證",
			communityTitle: "全球範圍入駐",
			community: "全球合作導師\n200+",
		},
		steps: {
			eyebrow: "3 Steps to Start",
			title: "三步入駐，開啟智慧變現之旅。",
			desc: "我們會快速了解你的專業與內容方向，並由專人協助完成後續上線。",
			step1Title: "提交申請",
			step1Desc: "填寫基本資料、內容領域\n與作品／社群連結。",
			step1Badge: "約 3 分鐘",
			step2Title: "資格審核",
			step2Desc: "團隊評估專業能力、內容品質\n與合作潛力。",
			step2Badge: "3 個工作日內",
			step3Title: "簽約上線",
			step3Desc: "開通創作者後台，由專屬營運\n協助規劃與上線。",
			step3Badge: "專人對接",
		},
	},
	join: {
		metaTitle: "申請成為創作者",
		title: "申請成為創作者",
		nickname: "昵称",
		nicknamePh: "請輸入昵称",
		gender: "性别",
		genderPh: "請選擇性別",
		genderFemale: "女",
		genderMale: "男",
		region: "地区",
		regionPh: "請選擇地區",
		intro: "个人介绍",
		introPh: "介紹你的經歷、內容特色與希望影響的受眾",
		expertise: "擅长领域",
		expertisePh: "請具體描述專業方向與服務能力",
		media: "媒体资料",
		mediaTip:
			"提供至少1個外部平台（如YouTube、Facebook、Instagram等）的主頁截圖，展示粉絲量及內容風格（需包含帳號名稱、粉絲數、近期作品），支持JPG、PNG，最多6张",
		contractType: "签约类型",
		contractPersonal: "个人签约",
		contractPersonalDesc: "以個人身份簽署合作協議",
		contractCompany: "公司签约",
		contractCompanyDesc: "以公司主體簽署合作協議",
		companyName: "公司名称",
		companyNamePh: "請輸入公司名稱",
		legalRep: "公乙方代表人（法人）",
		legalRepPh: "請輸入乙方代表人（法人）",
		legalTitle: "乙方代表職位",
		legalTitlePh: "請輸入乙方代表職位",
		registerCode: "公司註冊編碼",
		registerCodePh: "請輸入公司註冊編碼",
		companyAddress: "公司地址",
		companyAddressPh: "請輸入公司地址",
		email: "電郵",
		emailPh: "請輸入聯繫電郵",
		backHome: "返回首頁",
		submit: "檢查並提交申請",
		submitM: "提交申請",
		avatarAlt: "頭像",
		pickImage: "請選擇圖片文件",
		imageMax4mb: "圖片大小不能超過 4MB",
		uploadNoUrl: "上傳成功但未返回圖片地址",
		uploadSuccess: "上傳成功",
		uploadFail: "上傳失敗，請重試",
		submitOk: "申請已提交，請等待審核",
		submitFail: "提交失敗，請稍後重試",
		rules: {
			nickname: "請輸入昵称",
			gender: "請選擇性別",
			region: "請選擇地區",
			intro: "請填寫個人介紹",
			expertise: "請填寫擅長領域",
			media: "請至少上傳 1 張媒體資料",
			contractType: "請選擇簽約類型",
			companyName: "請輸入公司名稱",
			legalRep: "請輸入乙方代表人（法人）",
			legalTitle: "請輸入乙方代表職位",
			registerCode: "請輸入公司註冊編碼",
			companyAddress: "請輸入公司地址",
			email: "請輸入聯繫電郵",
			emailFormat: "請輸入正確的電郵格式",
		},
	},
	status: {
		download: "下载先知命局App",
		app: "See Beyond",
		back: "返回首頁",
		processing: {
			title: "資料審核中",
			text: "審核人員將於 3 個工作日內透過電子郵件回覆審核結果，敬請留意郵件收信。另可下載先知命局 App，即時接收審核進度與結果通知，感謝您的配合與支持。",
		},
		approved: {
			title: "歡迎加入SeerQ",
			text: "你已成為 SeerQ 認證創作者，立即前往先知命局 App 發佈內容，開啟創作之旅。",
		},
		rejected: {
			title: "很抱歉，您的創作者資質審核暫未通過。",
			reason: "原因",
			dec: "您可根據審核意見修改資料後重新提交申請。",
			edit: "去修改",
		},
	},
	gate: {
		officialCannotApplyCreator: "您已是認證導師，無法申請創作者入駐",
	},
};
